module.exports = __webpack_public_path__ + "static/media/7.question.7f7934ab.mp4";